export const CLINIC_CONFIG = {
  phoneDisplay: '0531 239 28 92', // WhatsApp & Doğrudan İletişim
  phoneRaw: '905312392892', // WhatsApp uluslararası numara
  landlineDisplay: '0224 334 0 318', // Kurumsal Klinik Sabit Numarası
  landlineRaw: '02243340318',
  address: 'Fatih Sultan Mehmet Bulvarı, BKM Yanı Nilüfer / BURSA',
  landmark: 'FSM Bulvarı Nilüfer (BKM Yanı) - Doktor Kliniği',
  workingHours: 'Yalnızca Randevu İle Hizmet Verilmektedir',
  domains: ['bursaerkeklazer.com', 'bursaerkeklazer.com.tr'],
  instagram: 'bursaerkeklazer',
  googleMapsUrl: 'https://maps.google.com/?q=Fethiye,+Ferhat+Sk,+16140+Nil%C3%BCfer/Bursa'
};

export function createWhatsAppLink(message: string, customPhone?: string): string {
  const encoded = encodeURIComponent(message);
  let targetPhone = customPhone || CLINIC_CONFIG.phoneRaw;
  
  // Normalize Turkish number format to international without +
  targetPhone = targetPhone.replace(/[^0-9]/g, '');
  if (targetPhone.startsWith('0')) {
    targetPhone = '9' + targetPhone;
  } else if (!targetPhone.startsWith('90') && targetPhone.length === 10) {
    targetPhone = '90' + targetPhone;
  }

  return `https://wa.me/${targetPhone}?text=${encoded}`;
}

export function createAreaWhatsAppMessage(areaName: string): string {
  return `Merhaba, bursaerkeklazer.com üzerinden ulaşıyorum. "${areaName}" bölgesi erkek lazer epilasyon uygulaması hakkında uzmanınızla görüşmek ve seans planı hakkında bilgi almak istiyorum.`;
}

export function createCustomQuoteWhatsAppMessage(params: {
  areas: string[];
  density: string;
  experience: string;
  name?: string;
}): string {
  const densityMap: Record<string, string> = {
    light: 'Hafif / Seyrek',
    medium: 'Orta Yoğunlukta',
    dense: 'Çok Yoğun / Kalın Kök'
  };

  const experienceMap: Record<string, string> = {
    first_time: 'İlk Defa Yaptıracağım (Kıl analizi istiyorum)',
    had_before: 'Daha Önce Yaptırdım (Devam / Rötuş seansı)'
  };

  const areasList = params.areas.length > 0 ? params.areas.join(', ') : 'Tüm Vücut / Genel';
  const densityText = densityMap[params.density] || 'Belirtilmedi';
  const expText = experienceMap[params.experience] || 'İlk Defa';
  const nameGreeting = params.name ? `Ben ${params.name}. ` : '';

  return `Merhaba, bursaerkeklazer.com üzerinden uzmanınızla görüşmek ve seans planı hakkında danışmak istiyorum.
${nameGreeting}
📌 İlgilendiğim Bölgeler: ${areasList}
📌 Kıl Yapım: ${densityText}
📌 Deneyim Durumu: ${expText}
📌 Lokasyon: FSM Bulvarı / Nilüfer

Bu bölgeler için uzman hekim / klinik asistanınızla görüşebilir miyim?`;
}
